import React, { useState, useEffect } from 'react';
import isValidUrl from './components/helpers/isValidUrl';
import isInteger from './components/helpers/isInteger';
import getQueryStringValue from './components/helpers/getQueryStringValue';
import HHPlayer from './components/Player/HHPlayer';
import Loader from './components/Loader';
// import Parser from 'rss-parser';
import Parser from './parser/rssParser'
let parser = new Parser();
const CORS_PROXY = "https://cors-anywhere.hubhopper.com/"

function App() {
	const [podcast, setPodcast] = useState(false);
	const [error, setError] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [order, setOrder] = useState('desc');

	const [chosenEpisode, setChosenEpisode] = useState(false);
	const [onlyEpisode, setOnlyEpisode] = useState(false);
	const [height, setHeight] = useState(false);

	const [episodeArr, setEpisodeArr] = useState([]);

	useEffect(() => {
	    try {
		    const url = atob(getQueryStringValue('feed'))
			
		    let orderParam = getQueryStringValue('order');
		    if (orderParam === 'asc') { setOrder(orderParam) }
		    
		    const chosenEpParam = getQueryStringValue('episode');
			if (chosenEpParam && isInteger(chosenEpParam)) { setChosenEpisode(chosenEpParam) }

			const onlyEpParam = getQueryStringValue('onlyEpisode');
			if (onlyEpParam == 'true') { 
				setOnlyEpisode(onlyEpParam == 'true');

			}
			const heightParam = getQueryStringValue('height');
			if (heightParam  === 'large') {
				setHeight(true);
			}

			const episodeArrParam = getQueryStringValue('list');
			
			if (episodeArrParam && episodeArrParam != '') {
				// %7B%0A%20%20%22episodes%22%3A%20%5B1%2C2%2C3%2C4%5D%0A%7D
				let obj = decodeURIComponent(episodeArrParam);
				try {
					obj = JSON.parse(obj);
					if (obj.episodes && Array.isArray(obj.episodes)) {
						setEpisodeArr(obj.episodes);
					}
				} catch (e) {
					console.log('Invalid custom selected list of episodes', e);
				}
			}
		    
		    async function fetchPodcast() {
				try {
					let parsedRSS = await parser.parseURL2(url);
					setPodcast(parsedRSS)
				} catch(e) {
					console.log("Error occurred. ", e);
					// try {
					// 	let parsedRSS = await parser.parseURL(CORS_PROXY + url);
					// 	setPodcast(parsedRSS)
					// } catch(e) {
					// 	console.log("Error occurred after proxy. ", e);
						setError(true)
						setErrorMsg('Could not fetch RSS')
					// }
				}
		    }

		    if (isValidUrl(url)) {
		    	fetchPodcast()
		    } else {
		    	setErrorMsg('Invalid Embed URL')
		    	setError(true)
		    }
	    } catch (e) {
			console.log("Error occurred. ", e);
			setError(true)
			setErrorMsg('Invalid Embed URL')
	    }
	}, [])

	return (
		<div className="App">
			{ 
				!error ? 
				( !podcast ? <Loader /> : <HHPlayer podcast={podcast} episodes={podcast.items} order={order} onlyEpisode={onlyEpisode} height={height} chosenEpisode={chosenEpisode} episodesToShow={episodeArr}/> )
				:
				<div className='d-flex justify-content-center align-items-center' style={{height:'100px'}}>
					{ errorMsg === '' ? 'Could not load' : errorMsg }
				</div>
			}
		</div>
	);
}

export default App;
